import { render, staticRenderFns } from "./productDel.vue?vue&type=template&id=391c5b17&scoped=true"
import script from "./productDel.vue?vue&type=script&lang=js"
export * from "./productDel.vue?vue&type=script&lang=js"
import style0 from "./productDel.vue?vue&type=style&index=0&id=391c5b17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c5b17",
  null
  
)

export default component.exports